import {
  DOWNLOAD_CLINICIAN_PLAN,
  DOWNLOAD_CLINICIAN_PLAN_FAILURE,
  DOWNLOAD_CLINICIAN_PLAN_SUCCESS,
} from '../../../actions/constants/types';

const initialState = {
  downloading: false,
};

const clinicianPlan = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_CLINICIAN_PLAN:
      return {
        downloading: true,
      };
    case DOWNLOAD_CLINICIAN_PLAN_SUCCESS:
    case DOWNLOAD_CLINICIAN_PLAN_FAILURE:
      return {
        downloading: false,
      };
    default:
      return state;
  }
};

export default clinicianPlan;
